import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    row: {
      "&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    link: {
      textDecoration: "underline",
    },
    button: {
      margin: [10, 0, 0],
    },
    left: {
      textAlign: "left",
    },
    center: {
      textAlign: "center",
    },
    right: {
      textAlign: "right",
    },
  }),
  { name: "Receipts" },
);
